import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UList',
    props: {
        flexDirection: {
            type: String,
            default: "column"
        },
        gap: {
            type: String,
            default: "20px"
        },
        alignItems: {
            type: String,
            default: "flex-start"
        },
        justifyContent: {
            type: String,
            default: "flex-start"
        }
    },
    setup(__props) {
        const props = __props;
        const cssVars = computed(() => ({
            "flex-direction": props.flexDirection,
            gap: props.gap,
            "align-items": props.alignItems,
            "justify-content": props.justifyContent
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "flex",
                style: _normalizeStyle(cssVars.value)
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 4));
        };
    }
});
